import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { ReactComponent as RemoveSVG } from '../../../../assets/svg/remove.svg';

export const CancelButton: React.FC<{
  setShowModal: ({ show, id }: { show: boolean; id: string }) => void;
  id: string;
}> = ({ setShowModal, id }) => {
  return (
    <IconButton
      h="100%"
      minW={0}
      size="lg"
      variant="ghost"
      icon={<RemoveSVG />}
      onClick={() => setShowModal({ show: true, id: id })}
      aria-label="Detalhes do serviço"
      color="button"
    />
  );
};
